module.exports = (search) =>
  searchTerms = search.toLowerCase().split(/[\s,]+/)

  tests = searchTerms.map (term, index) =>
    if term.length == 0
      (s) -> true
    else if index == searchTerms.length - 1
      # Assume the last term is a partial
      (s) ->
        s.toLowerCase().indexOf(term) == 0
    else
      (s) ->
        s.toLowerCase() == term

  (word) =>
    if Array.isArray(word)
      word = word.join(' ')

    terms = word.toLowerCase().split(/\s+/)
    # We've got to have a match for every search term
    tests.every (fn) ->
      terms.some (term) -> fn(term)
